<script setup>
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

const props = defineProps({
    invoiceTax: Object,
    agent: Object,
});

dayjs.extend(advancedFormat);

function formatPrice(value) {
    let val = (value / 1).toFixed(2).replace('.', '.');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatPriceRoundOff(value) {
    let val = (value / 1).toFixed(0).replace('.', '.');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function getServiceFee() {
    let serviceFee = props.invoiceTax.total_payable - props.invoiceTax.room_rate;
    let totalserviceFee = serviceFee / 118 * 100;
    return totalserviceFee;
}

function getMumbaiTax() {
    let serviceFee = props.invoiceTax.total_payable - props.invoiceTax.room_rate;
    let mumbaiTax = serviceFee / 118 * 100;
    let finalMumbaiTax = mumbaiTax * 0.18;
    return finalMumbaiTax;
}

function getTotalAmount(tcs) {
    let serviceFee = props.invoiceTax.total_payable - props.invoiceTax.room_rate;
    let eighteenPtax = serviceFee / 118 * 100;
    if (tcs == 1) {
        return eighteenPtax + (eighteenPtax * 18 / 100);
    }
    return serviceFee;
}

//convert number to words
function convertNumberToWords(amount) {
    let words = new Array();
    words[0] = '';
    words[1] = 'One';
    words[2] = 'Two';
    words[3] = 'Three';
    words[4] = 'Four';
    words[5] = 'Five';
    words[6] = 'Six';
    words[7] = 'Seven';
    words[8] = 'Eight';
    words[9] = 'Nine';
    words[10] = 'Ten';
    words[11] = 'Eleven';
    words[12] = 'Twelve';
    words[13] = 'Thirteen';
    words[14] = 'Fourteen';
    words[15] = 'Fifteen';
    words[16] = 'Sixteen';
    words[17] = 'Seventeen';
    words[18] = 'Eighteen';
    words[19] = 'Nineteen';
    words[20] = 'Twenty';
    words[30] = 'Thirty';
    words[40] = 'Forty';
    words[50] = 'Fifty';
    words[60] = 'Sixty';
    words[70] = 'Seventy';
    words[80] = 'Eighty';
    words[90] = 'Ninety';
    amount = amount.toString();
    let atemp = amount.split(".");
    let number = atemp[0].split(",").join("");
    let n_length = number.length;
    let words_string = "";
    if (n_length <= 9) {
        let n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
        let received_n_array = new Array();
        for (let i = 0; i < n_length; i++) {
            received_n_array[i] = number.substr(i, 1);
        }
        for (let i = 9 - n_length, j = 0; i < 9; i++, j++) {
            n_array[i] = received_n_array[j];
        }
        for (let i = 0, j = 1; i < 9; i++, j++) {
            if (i == 0 || i == 2 || i == 4 || i ==
                7) {
                if (n_array[i] == 1) {
                    n_array[j] = 10 + parseInt(n_array[j]);
                    n_array[i] = 0;
                }
            }
        }
        let value = "";
        for (let i = 0; i < 9; i++) {
            if (i == 0 || i == 2 || i == 4 || i ==
                7) {
                value = n_array[i] * 10;
            } else {
                value = n_array[i];
            }
            if (value != 0) {
                words_string += words[value] + " ";
            }
            if ((i == 1 && value != 0) || (i == 0 &&
                value != 0 && n_array[i + 1] == 0)) {
                words_string += "Crores ";
            }
            if ((i == 3 && value != 0) || (i == 2 &&
                value != 0 && n_array[i + 1] == 0)) {
                words_string += "Lakhs ";
            }
            if ((i == 5 && value != 0) || (i == 4 &&
                value != 0 && n_array[i + 1] == 0)) {
                words_string += "Thousand ";
            }
            if (i == 6 && value != 0 && (n_array[i +
                1] != 0 && n_array[i + 2] != 0)) {
                words_string += "Hundred and ";
            } else if (i == 6 && value != 0) {
                words_string += "Hundred ";
            }
        }
        words_string = words_string.split("  ").join(" ");
    }
    return words_string;
}
</script>

<template>
    <div class="row invoice-preview">
        <div class="col-xl-9 col-md-8 col-12">
            <div class="card invoice-preview-card">
                <div class="card-body pb-0">
                    <div
                        class="d-flex justify-content-between flex-xl-row flex-md-column flex-sm-row flex-column p-sm-3 p-0">
                        <div class="mb-xl-0 mb-4">
                            <div class="d-flex svg-illustration mb-3 gap-2">
                                <span class="app-brand-logo demo">
                                    <img style="width:140px;" src="/storage/company_logos/company_logo.png" alt="logo">
                                </span>
                            </div>
                            <span v-html="props.agent?.address2"></span>
                        </div>
                        <div>
                            <h4>Tax Invoice</h4>
                            <div class="mb-2">
                                <span class="me-1">Invoice No:</span>
                                <span class="fw-semibold">{{ props.invoiceTax.invoice_no }}</span>
                            </div>
                            <div>
                                <span class="me-1">Invoice Date:</span>
                                <span class="fw-semibold">{{ dayjs(props.invoiceTax.created_at).format('Do MMM YYYY')
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="my-0" />

                <div class="card-body">
                    <div class="row p-sm-3 p-0">
                        <div class="col-xl-6 col-md-12 col-sm-5 col-12 mb-xl-0 mb-md-4 mb-sm-0 mb-4">
                            <h6 class="pb-2">Invoice To:</h6>
                            <p class="mb-1">{{ props.invoiceTax.otherbookings.agent?.agency_name }}</p>
                            <p class="mb-1">{{ props.invoiceTax.otherbookings.agent?.agency_address }}</p>
                            <p class="mb-1"><b>Tax ID (TIN):</b> {{ props.invoiceTax.otherbookings.agent?.agency_TIN }}
                            </p>
                            <p class="mb-1"><b>Email:</b> {{ props.invoiceTax.otherbookings.agent?.agency_email }}</p>
                        </div>
                        <div class="col-xl-6 col-md-12 col-sm-7 col-12"
                            style="background-color: #e1f5fe; border-radius:3px; padding:25px;">
                            <table>
                                <tbody>
                                    <tr>
                                        <td class="pe-3"><strong>Booking Number:</strong></td>
                                        <td><strong>{{ props.invoiceTax.otherbookings?.booking_no }}</strong></td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Arrival Date:</strong></td>
                                        <td>{{ dayjs(props.invoiceTax.otherbookings?.arrival_date).format('Do MMM YYYY')
                                            }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Departure Date:</strong></td>
                                        <td>{{ dayjs(props.invoiceTax.otherbookings?.departure_date).
                                            format('Do MMM YYYY') }}</td>
                                    </tr>
                                    <tr>
                                        <td class="pe-3"><strong>Guest Name:</strong></td>
                                        <td>{{ props.invoiceTax.otherbookings?.guest_name }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table">
                        <thead class="table-active">
                            <tr>
                                <th>BOOKING DETAILS</th>
                                <th>ROOM RATE</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="col-md-8">
                                    <div v-for="location in props.invoiceTax.otherbookings?.otherbookinglocations"
                                        :key="location.id">
                                        {{ location.hotel_name }} <b>For</b> {{ location.nights }} Nights
                                    </div>
                                    <span v-if="props.invoiceTax.otherbookings.stay_type == 1"><b>(Split
                                            Stay)</b></span>
                                </td>
                                <td class="col-md-4">
                                    <b>{{ props.invoiceTax.currency }}</b> {{ formatPrice(props.invoiceTax.room_rate) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="row">
                        <div class="col-md-6" style="padding-right:0;">
                            <table class="table">
                                <thead class="table-active">
                                    <tr>
                                        <th>DESCRIPTION OF SERVICE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><b>HOTEL ACCOMMODATION CHARGES (Service Fee)</b></td>
                                    </tr>
                                    <tr v-if="props.invoiceTax.otherbookings.agent.city.name == 'Mumbai'">
                                        <td><b>Central GST @ 9%</b></td>
                                    </tr>
                                    <tr v-if="props.invoiceTax.otherbookings.agent.city.name == 'Mumbai'">
                                        <td><b>IGST @ 9%</b></td>
                                    </tr>
                                    <tr v-if="props.invoiceTax.otherbookings.agent.city.name != 'Mumbai'">
                                        <td><b>IGST @ 18%</b></td>
                                    </tr>
                                    <tr>
                                        <td><b>TOTAL AMOUNT</b></td>
                                    </tr>
                                    <tr>
                                        <td><b>Total Amount Payable (Accommodation Charges + Service Fees)</b></td>
                                    </tr>
                                    <tr>
                                        <td><b>Amount in words</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-md-6" style="padding-left:0;">
                            <table class="table">
                                <thead class="table-active">
                                    <tr>
                                        <th>TAXABLE VALUE OF SUPPLY (Rs.)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ formatPriceRoundOff(getServiceFee()) }}</td>
                                    </tr>
                                    <tr v-if="props.invoiceTax.otherbookings.agent.city.name == 'Mumbai'">
                                        <td>{{ formatPriceRoundOff(getMumbaiTax() / 2) }}</td>
                                    </tr>
                                    <tr v-if="props.invoiceTax.otherbookings.agent.city.name == 'Mumbai'">
                                        <td>{{ formatPriceRoundOff(getMumbaiTax() / 2) }}</td>
                                    </tr>
                                    <tr v-if="props.invoiceTax.otherbookings.agent.city.name != 'Mumbai'">
                                        <td>{{ formatPriceRoundOff(getMumbaiTax()) }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ formatPriceRoundOff(getTotalAmount(props.invoiceTax.tcs)) }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ formatPrice(props.invoiceTax.total_payable) }}</td>
                                    </tr>
                                    <tr valign=top>
                                        <td>
                                            {{ convertNumberToWords(props.invoiceTax.total_payable) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <table class="table">
                        <tbody>
                            <tr>
                                <td colspan="2" class="align-top px-4 py-3" style=" ">
                                    <p class="mb-3 col-md-6">
                                        <span class="me-1 fw-semibold" style="font-size: 14px;"><b>Arrange
                                                Payment by Bank Transfers to
                                                Our Bank Account in INR</b></span>
                                    </p>
                                    <span>
                                        <p>Account Name: PLAN ISLAND TRAVEL PVT LTD<br>
                                            Bank Name: ICICI Bank<br>
                                            Bank Account Number: 120205000974<br>
                                            IFSC Code: ICIC0001202<br>
                                            Branch: Shop No. 15, Kanakia Zillion, LBS Marg,<br>
                                            Kurla (W), Mumbai-400070</p>
                                    </span>
                                </td>
                                <td>
                                    <p class="mb-2 fw-semibold"><b>SERVICE ACCOUNTING CODE: 998552</b></p>
                                    <p class="mb-2 fw-semibold"><b>GST IN: 27AAKCP7338P1ZJ</b></p>
                                    <p class="mb-2 fw-semibold"><b>PAN NUMBER: AAKCP7338P</b></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <span>This is a computer-generated document and does not require a signature.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>